import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Migration/Migration.ts";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import { createEvent, createStore } from 'effector';
import { useStore, useStoreMap } from 'effector-react';
import * as api from '@gmini/sm-api-sdk';
import { isJsendBadResultError, isJsendBadResultFail } from '@gmini/api-call-service';
api.migrate.done.watch(function () {
  return window.location.reload();
});
export var reset = createEvent('reset', {
  name: "reset",
  sid: "k50dvy"
});
export var resetDiff = createEvent('resetDiff', {
  name: "resetDiff",
  sid: "ke9b1g"
});
export var clsDiff$ = createStore(null, {
  name: "clsDiff$",
  sid: "-tdrezi"
}).on(api.getBaseClassifierVersionDiff.doneData, function (_, diff) {
  return diff;
}).on(api.getAssemblyClassifierVersionDiff.doneData, function (_, diff) {
  return diff;
}).reset(reset, resetDiff);
export var conflicts$ = createStore(null, {
  name: "conflicts$",
  sid: "-z7xprl"
}).on(api.getUserClassifierMigrationConflicts.doneData, function (_, conflicts) {
  return conflicts;
}).reset(reset, resetDiff);
export var useDiff = function useDiff() {
  return useStore(clsDiff$);
};
export var useConflicts = function useConflicts() {
  return useStore(conflicts$);
};
export var versions$ = createStore({}, {
  name: "versions$",
  sid: "ftyofg"
}).on(api.getSourceClassifiersVersions.doneData, function (state, _ref) {
  var dependencies = _ref.dependencies;
  return dependencies.reduce(function (acc, dependency) {
    acc[dependency.entityId] = dependency;
    return acc;
  }, _objectSpread({}, state));
}).reset(reset);
export var useVersions = function useVersions(id) {
  return useStoreMap({
    store: versions$,
    keys: [id],
    fn: function fn(versions, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          id = _ref3[0];

      return id ? versions[id] || null : null;
    }
  });
};
export function useHasUpdates(id) {
  var versions = useVersions(id);
  return !!versions && versions.currentVersion !== versions.latestVersion;
}
var errCodesMap = {
  DEPENDENCIES_ALREADY_HAS_MODEL_DIFFERENT_VERSION: 'Вы не можете обновить версию модели, т.к. в зависимости есть пользовательский классификатор основанный на этой модели'
};
export var migrateFailMessage = api.migrate.failData.filter({
  fn: isJsendBadResultFail
}).map(function (res) {
  var _res$data;

  var errorCode = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.errorCode;

  if (errorCode in errCodesMap) {
    return {
      mappedMessage: errCodesMap[errorCode],
      errorCode: errorCode,
      res: res
    };
  }

  return {
    errorCode: errorCode,
    mappedMessage: null,
    res: res
  };
});
export var migrateSystemError = api.migrate.failData.filter({
  fn: isJsendBadResultError
}).map(function (res) {
  return {
    mappedMessage: null,
    errorCode: res.status || null,
    res: res
  };
});